module.exports = __webpack_public_path__ + "static/media/icon_ok.f0f15b45.svg";